import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=a0b6d920"
import script from "./AvatarUpload.vue?vue&type=script&lang=js"
export * from "./AvatarUpload.vue?vue&type=script&lang=js"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&id=a0b6d920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports